import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { formFieldMounted } from 'actions/scheduling'

const BookingField = ({ children }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(formFieldMounted())
  }, [dispatch])

  return children
}

export default BookingField
